import constActivity from './constActivity';
import constAreas from './constAreas';
import constBath from './constBath';
import constBusinessPeriod from './constBusinessPeriod';
import constCarStock from './constCarStock';
import constCheckInCheckOut from './constCheckInCheckOut';
import constEquipment from './constEquipment';
import constLocations from './constLocations';
import constOnSiteEquipment from './constOnSiteEquipment';
import constService from './constService';

export const ConstSearch = {
  area: constAreas,
  equipment: constEquipment,
  location: constLocations,
  carStock: constCarStock,
  bath: constBath,
  businessPeriod: constBusinessPeriod,
  checkIn: constCheckInCheckOut,
  details: [constOnSiteEquipment, constService, constActivity],
};
